import { createContext } from 'react'

export interface ConversationActionsContext {
  refetchConversations: () => void
}

const ConversationActionsCtx = createContext<ConversationActionsContext>({
  refetchConversations: () => {},
})

export default ConversationActionsCtx
